'use client';

import type { CollectionResponseDtoRarity } from '~/lib/api';
import { BaseCard } from '../base-card';

interface PossibleDropFromUnwrapCardProps {
  id: string;
  label: number | string;
  imageSrc: string | null;
  imagePosition?: 'contain' | 'cover';
  title: string;
  brandName?: string | null;
  className?: string;
  dropChance: number;
  rarity: CollectionResponseDtoRarity;
}

export const PossibleDropFromUnwrapCard = ({
  label,
  rarity,
  imageSrc,
  imagePosition,
  title,
  brandName,
  className,
  id,
  dropChance,
  ...props
}: PossibleDropFromUnwrapCardProps) => (
  <BaseCard
    badgeText={`${dropChance}%`}
    brandName={brandName}
    className={className}
    imagePosition={imagePosition}
    imageSrc={imageSrc}
    label={label}
    rarity={rarity}
    title={title}
    {...props}
  />
);
